import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import VueRecaptcha from 'vue-recaptcha';
import GoogleLogin from 'vue-google-login';

export default {
  name: 'login',
  components: {
    VueElementLoading,
    'vue-recaptcha': VueRecaptcha,
    GoogleLogin
  },
  props: [],
  data() {
    return {
      username: '',
      showPass: false,
      password: '',
      errormsg: '',
      isLoading: false,
      isVerified : 0,
      captchaKey : apiUrl.captchaSiteKey,
      captchaToken : '',
      params: {
        client_id: "321012318929-1osvj0eaah8intsn6hlntophgirtorsl.apps.googleusercontent.com",
        plugin_name: 'userauth'
      },
      renderParams: {
        width: 250,
        height: 50,
        longtitle: true
    },
    env:'production'
    }
  },
  computed: {

  },
  mounted() {
      if(this.env=='development'){
        this.isVerified = 1
        this.captchaToken=this.env
      }
  },
  methods: {
    onVerify (response) {
      this.isVerified = 1
      this.captchaToken = response
    },
    // sendOTP(){
    //     this.$router.push('/forgotpassword');
    // },
    sendotpforvalid2fa(){
     this.$router.push('/resetpasswordwith2fa?redirecturl=' + window.location.href);
    },
    logoutUser(){
        this.$router.push('/forcelogout');
    },

    checklogin() {
      if(this.isVerified == 1){
        this.isLoading = true;
        axios.post(apiUrl.api_url + 'external/verifyCaptcha',{
          responseToken : this.captchaToken
        }).then((result)=>{
          /*--maintenance page call start--*/
          if(result && result.data.ReturnCode=='104')
          {
            this.$router.push("/maintenance");
          }
          /*--maintenance page call end--*/
          if(result.data.code == 100){
            axios.post(apiUrl.api_url + 'auth', {
                'email': this.username,
                'password': this.password
              })
              .then((response) => {
                this.isLoading = false;
                if(response.data.code==200){
                  this.input = {
                    email: this.username,
                    password: this.password,
                    projectid:3
                  };
                  var token = JSON.stringify(response.data.token);
                  axios({
                    method: "POST",
                    url: apiUrl.api_url + "validateUser",
                    data: this.input,
                    headers: {
                      'Authorization': 'Bearer ' + response.data.token
                    }
                    }).then((response) => {
                      if (response.data[0].userdetail.length <= 0) {
                        this.errormsg = "Login Failed. "+response.data[0].error;
                      }

                      if (response.data[1].permissions.length > 0) {
                        //debugger
                        var permissionEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data[1].permissions), "Key");
                        var userdetailEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data[0].userdetail), "Key");
                        window.localStorage.setItem('permissiondata', permissionEncrypt);
                        window.localStorage.setItem('userdetail', userdetailEncrypt);
                        window.localStorage.setItem('isLoggedIn', true);
                        window.localStorage.setItem('userToken', token);
                        window.localStorage.setItem('userToken', token);
                        window.localStorage.setItem('encryPassword', response.data[0].encryPassword);

                        var userdetailEncrypt = window.localStorage.getItem('userdetail')
                        var permissionEncrypt = window.localStorage.getItem('permissiondata')
                        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
                        var permissiondatabytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
                        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                        var permissiondataplaintext = permissiondatabytes.toString(CryptoJS.enc.Utf8);

                        var userdetail = JSON.parse(plaintext);
                        var permissiondata = JSON.parse(permissiondataplaintext);
                        var usertype = userdetail.utype;

                        if (usertype === null || usertype === '') {
                          this.$router.push('/'+permissiondata[0].url);
                          this.$alertify.success("Logged In Successfully");
                        } else {
                          this.$router.push('/'+permissiondata[0].url);
                          this.$alertify.success("Logged In Successfully");
                        }
                      }
                    }).catch((httpException) => {
                     if(this.env!='development'){
                        grecaptcha.reset();
                         }
                      //this.$alertify.success("Logging Failed");
                      console.error('exception is:::::::::', httpException)
                    })
                  }else if(response.data.code == 302){
                    //console.log("redirect");
                    window.location.href= response.data.redirecturl;
                  }else{
                   if(this.env!='development'){
                    grecaptcha.reset();
                     }
                    //this.$alertify.error("Logging Failed");
                    this.errormsg = "Invalid Login Credentials";
                  }
                })
              .catch((httpException) => {
                if(this.env!='development'){
                grecaptcha.reset();
                 }
                //this.$alertify.error("Logging Failed");
                this.errormsg = "Login Failed";
                console.error('exception is:::::::::', httpException)
              })
          }
          else{
            if(this.env!='development'){
                grecaptcha.reset();
                 }
            this.errormsg = 'Captcha verification failed.'
          }
        })
      }
      else{
        this.isVerified = 2
      }
    },

    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.checklogin(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    onSuccess(googleUser) {
      let AuthResponse = googleUser.getAuthResponse();
      let profile = googleUser.getBasicProfile();
      let IDtoken = AuthResponse.id_token;
      let email = profile.getEmail();
      // let tokenExpiresin = AuthResponse.expires_in;
      // let isSignedIn = googleUser.isSignedIn()
      // let get_id = googleUser.getId();
  
      if(window.localStorage.getItem('isLoggedIn')&&
        window.localStorage.getItem('permissiondata')&&
        window.localStorage.getItem('userdetail')){
        let permissiondataencrypt = window.localStorage.getItem('permissiondata')
        let permissionbytes = CryptoJS.AES.decrypt(permissiondataencrypt.toString(), "Key");
        var plaintext = permissionbytes.toString(CryptoJS.enc.Utf8);
        var permission = JSON.parse(plaintext);
        this.goToLandingPage(permission[0].url)
      }else{
      this.isLoading = true;
      axios.post(apiUrl.api_url + 'auth/googlesignin', {
        'email': email,
        'GoogleIDtoken': IDtoken
      })
      .then((response,error) => {
        this.isLoading = false;

        if(response.data[0].error){
          this.$alertify.error(response.data[0].error);
          return;
        }
        else if(!response || response.status != 200 || error ){
          this.$alertify.error("Login failed");
          return;
        }else if(response.data[0].userdetail && response.data[1].permissions.length>0 ){
          let permissionEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data[1].permissions), "Key");
          let userdetailEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data[0].userdetail), "Key");
          window.localStorage.setItem('permissiondata', permissionEncrypt);
          window.localStorage.setItem('userdetail', userdetailEncrypt);
          window.localStorage.setItem('isLoggedIn', true);
          window.localStorage.setItem('userToken', response.data[2].token);
          window.localStorage.setItem('encryPassword', response.data[0].encryPassword);
          let url = response.data[1].permissions[0].url;
          this.goToLandingPage(url);        
        }else{
          this.$alertify.error("Unknown error occured while login");
          return;
        }
      });
    }
    },
  onFailure(){
            this.isLoading = false;
            this.$router.push('/login');
            this.$alertify.error("Login failed.","","error");
  },
  goToLandingPage(landingPage){
    this.$router.push('/'+landingPage);
    this.$alertify.success("Logged In successfully")
  }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/login/login.component.js